"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./Button.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Button(_ref) {
  var active = _ref.active,
      Component = _ref.componentEl,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      margin = _ref.margin,
      primary = _ref.primary,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      justified = _ref.justified,
      size = _ref.size,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["active", "componentEl", "children", "className", "color", "disabled", "fullWidth", "icon", "iconPosition", "margin", "primary", "secondary", "tertiary", "justified", "size"]);

  var cssClasses = ['st_btn'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  if (primary || secondary) cssClasses.push("st_btn--size-" + size);

  if (primary) {
    cssClasses.push('st_btn--primary');
  } else if (secondary) {
    cssClasses.push('st_btn--secondary');
  } else if (tertiary) {
    cssClasses.push('st_btn--tertiary');
  }

  if (active) cssClasses.push('st_btn--active');
  if (fullWidth) cssClasses.push('st_btn--full-width');
  if (disabled) cssClasses.push('st_btn--disabled');
  if (color && tertiary) cssClasses.push("st_btn--tertiary--" + color);

  var componentProps = _extends({}, otherProps); // add back disabled attribute only for button


  if (Component === 'button') {
    componentProps.disabled = disabled;
  } // don't add margin to button if there's no other content


  var buttonMargin = size === 'sm' ? 'xs' : 'sm';

  if (icon && !children) {
    buttonMargin = 'none';
  } // overwrite justify-content if justification included


  if (justified) {
    if (fullWidth) cssClasses.push("st_btn--justified-" + justified);
  }

  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, componentProps), icon && iconPosition === 'left' && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: icon,
    size: "md",
    margin: {
      right: buttonMargin
    },
    className: "btn__icon"
  }), children, icon && iconPosition === 'right' && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: icon,
    size: "md",
    margin: {
      left: buttonMargin
    },
    className: "btn__icon"
  }));
}

Button.propTypes = {
  /** whether button should show as active */
  active: _propTypes["default"].bool,

  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** color, but applied only for tertiary */
  color: _propTypes["default"].oneOf(['asphalt', 'blurple', 'emerald', 'gray', 'lava', 'white']),

  /** whether link/button is disabled */
  disabled: _propTypes["default"].bool,

  /** whether button takes up all available horizontal space */
  fullWidth: _propTypes["default"].bool,

  /** name of icon, if any */
  icon: _propTypes["default"].string,

  /** position of icon relative to text */
  iconPosition: _propTypes["default"].oneOf(['left', 'right']),

  /** left/top/right/bottom, and also size */
  margin: utils.spacing.marginProps,

  /** whether button is Primary */
  primary: _propTypes["default"].bool,

  /** whether buttonis Secondary */
  secondary: _propTypes["default"].bool,

  /** whether button is tertiary */
  tertiary: _propTypes["default"].bool,

  /** justification of button */
  justified: _propTypes["default"].oneOf(['left', 'right', 'center']),

  /** size of button. Valid for primary and secondary only  */
  size: _propTypes["default"].oneOf(['sm', 'md'])
};
Button.defaultProps = {
  active: false,
  componentEl: 'button',
  className: null,
  color: null,
  disabled: false,
  fullWidth: false,
  icon: null,
  iconPosition: 'left',
  margin: null,
  primary: false,
  secondary: false,
  tertiary: false,
  justified: null,
  size: 'md'
};
var _default = Button;
exports["default"] = _default;